import { gsap, Power4 } from 'gsap';
import { Scroll } from '../_app/cuchillo/scroll/Scroll';
import { GetBy } from '../_app/cuchillo/core/Element';
import ScrollItem__BlockDefault from './ScrollItem__BlockDefault';

class ScrollItem__ReportStatComplex extends ScrollItem__BlockDefault {
    stats = [];
    timeline;
    hasPlayed = false;

    constructor(__link, __index, __scroller) {
        super(__link, __index, __scroller);

        this.setupStats();
        this.onShow = () => {};
        this.onHide = () => this.hideStats();
        this.onMove = () => this.checkShow();
    }

    setupStats() {
        this.stats = [];

        GetBy.selector('.content > li', this.item).forEach((el) => {
            const target1 = parseFloat(el.getAttribute('data-value-1')) || 0;
            const target2 = parseFloat(el.getAttribute('data-value-2')) || 0;
            const target3 = parseFloat(el.getAttribute('data-value-3')) || 0;

            const item = {
                el,
                target1,
                target2,
                target3,
                obj: { val1: 0, val2: 0, val3: 0 },
            };

            this.updateStat(item);
            this.stats.push(item);
        });

        this.timeline = gsap.timeline({ paused: true });

        this.stats.forEach((item, i) => {
            this.timeline.fromTo(
                item.obj,
                { val1: 0, val2: 0, val3: 0 },
                {
                    val1: item.target1,
                    val2: item.target2,
                    val3: item.target3,
                    duration: .8 + (i * 0.1),
                    ease: Power4.easeOut,
                    onUpdate: () => this.updateStat(item),
                },
                i * 0.05
            );
        });
    }

    updateStat(item) {
        item.el.style.setProperty('--value-1', item.obj.val1);
        item.el.style.setProperty('--value-2', item.obj.val2);
        item.el.style.setProperty('--value-3', item.obj.val3);
    }

    checkShow() {
        if (this.hasPlayed) return;
        if (this.progressToTop < 0.5) return;

        this.hasPlayed = true;
        this.showStats();
    }

    showStats() {
        this.timeline.restart();
    }

    hideStats() {
        this.hasPlayed = false;
        this.timeline.pause(0);
        this.stats.forEach((item) => {
            item.obj.val1 = 0;
            item.obj.val2 = 0;
            item.obj.val3 = 0;
            this.updateStat(item);
        });
    }
}

Scroll._registerClass('ReportStatComplex', ScrollItem__ReportStatComplex);

export default ScrollItem__ReportStatComplex;
